export const PRESENCE_COLORS = [
	{
		cursor: "bg-rainbow-lighter-0-solid",
		text: "text-rainbow-dark-0-solid",
		selection: "bg-rainbow-light-0-translucent",
		activeUser: "bg-rainbow-light-0-solid",
		border: "border-rainbow-light-0-solid",
	},
	{
		cursor: "bg-rainbow-lighter-1-solid",
		text: "text-rainbow-dark-1-solid",
		selection: "bg-rainbow-light-1-translucent",
		activeUser: "bg-rainbow-light-1-solid",
		border: "border-rainbow-light-1-solid",
	},
	{
		cursor: "bg-rainbow-lighter-2-solid",
		text: "text-rainbow-dark-2-solid",
		selection: "bg-rainbow-light-2-translucent",
		activeUser: "bg-rainbow-light-2-solid",
		border: "border-rainbow-light-2-solid",
	},
	{
		cursor: "bg-rainbow-lighter-3-solid",
		text: "text-rainbow-dark-3-solid",
		selection: "bg-rainbow-light-3-translucent",
		activeUser: "bg-rainbow-light-3-solid",
		border: "border-rainbow-light-3-solid",
	},
	{
		cursor: "bg-rainbow-lighter-4-solid",
		text: "text-rainbow-dark-4-solid",
		selection: "bg-rainbow-light-4-translucent",
		activeUser: "bg-rainbow-light-4-solid",
		border: "border-rainbow-light-4-solid",
	},
	{
		cursor: "bg-rainbow-lighter-5-solid",
		text: "text-rainbow-dark-5-solid",
		selection: "bg-rainbow-light-5-translucent",
		activeUser: "bg-rainbow-light-5-solid",
		border: "border-rainbow-light-5-solid",
	},
	{
		cursor: "bg-rainbow-lighter-6-solid",
		text: "text-rainbow-dark-6-solid",
		selection: "bg-rainbow-light-6-translucent",
		activeUser: "bg-rainbow-light-6-solid",
		border: "border-rainbow-light-6-solid",
	},
	{
		cursor: "bg-rainbow-lighter-7-solid",
		text: "text-rainbow-dark-7-solid",
		selection: "bg-rainbow-light-7-translucent",
		activeUser: "bg-rainbow-light-7-solid",
		border: "border-rainbow-light-7-solid",
	},
	{
		cursor: "bg-rainbow-lighter-8-solid",
		text: "text-rainbow-dark-8-solid",
		selection: "bg-rainbow-light-8-translucent",
		activeUser: "bg-rainbow-light-8-solid",
		border: "border-rainbow-light-8-solid",
	},
	{
		cursor: "bg-rainbow-lighter-9-solid",
		text: "text-rainbow-dark-9-solid",
		selection: "bg-rainbow-light-9-translucent",
		activeUser: "bg-rainbow-light-9-solid",
		border: "border-rainbow-light-9-solid",
	},
	{
		cursor: "bg-rainbow-lighter-10-solid",
		text: "text-rainbow-dark-10-solid",
		selection: "bg-rainbow-light-10-translucent",
		activeUser: "bg-rainbow-light-10-solid",
		border: "border-rainbow-light-10-solid",
	},
	{
		cursor: "bg-rainbow-lighter-11-solid",
		text: "text-rainbow-dark-11-solid",
		selection: "bg-rainbow-light-11-translucent",
		activeUser: "bg-rainbow-light-11-solid",
		border: "border-rainbow-light-11-solid",
	},
	{
		cursor: "bg-rainbow-lighter-12-solid",
		text: "text-rainbow-dark-12-solid",
		selection: "bg-rainbow-light-12-translucent",
		activeUser: "bg-rainbow-light-12-solid",
		border: "border-rainbow-light-12-solid",
	},
	{
		cursor: "bg-rainbow-lighter-13-solid",
		text: "text-rainbow-dark-13-solid",
		selection: "bg-rainbow-light-13-translucent",
		activeUser: "bg-rainbow-light-13-solid",
		border: "border-rainbow-light-13-solid",
	},
	{
		cursor: "bg-rainbow-lighter-14-solid",
		text: "text-rainbow-dark-14-solid",
		selection: "bg-rainbow-light-14-translucent",
		activeUser: "bg-rainbow-light-14-solid",
		border: "border-rainbow-light-14-solid",
	},
	{
		cursor: "bg-rainbow-lighter-15-solid",
		text: "text-rainbow-dark-15-solid",
		selection: "bg-rainbow-light-15-translucent",
		activeUser: "bg-rainbow-light-15-solid",
		border: "border-rainbow-light-15-solid",
	},
	{
		cursor: "bg-rainbow-lighter-16-solid",
		text: "text-rainbow-dark-16-solid",
		selection: "bg-rainbow-light-16-translucent",
		activeUser: "bg-rainbow-light-16-solid",
		border: "border-rainbow-light-16-solid",
	},
];
export const startIndex = Math.round(Math.random() * (PRESENCE_COLORS.length - 1));

export const getPresenceColor = (index: number) =>
	PRESENCE_COLORS[(startIndex + index * 2) % PRESENCE_COLORS.length];
